export default "__VITE_ASSET__e17c3a34__"